<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 24 24" :class="[`${prefix}-icon`, `${prefix}-icon-plug`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_236b0cdd2e__a"><rect width="24" height="24" rx="0"/></clipPath></defs><g clip-path="url(#svg_236b0cdd2e__a)"><path d="M4.5,10.0806L4.5,7.25Q4.5,6.11091,5.30545,5.30545Q6.11091,4.49999,7.25,4.5L10.0806,4.5Q10.27698,3.62684,10.9519,2.951904Q11.90381,2.00000143051,13.25,2Q14.5962,2,15.5481,2.951904Q16.223,3.62684,16.4194,4.5L19.25,4.5Q20.3891,4.5,21.1945,5.30545Q22,6.11091,22,7.25L22,10.0806L22,10.25003C22,10.94039,21.4404,11.50003,20.75,11.50003Q20.0251,11.50003,19.5126,12.0126Q19,12.5251,19,13.25Q19,13.9749,19.5126,14.4875Q20.0251,15,20.75,15C21.4404,15,22,15.5597,22,16.25L22,16.4194L22,19.25Q22,20.3891,21.1945,21.1946Q20.3891,22,19.25,22L7.25,22Q6.11091,22,5.30545,21.1946Q4.49999,20.3891,4.5,19.25L4.5,16.4194Q3.62684,16.223,2.951904,15.5481Q2.00000190735,14.5962,2,13.25Q2,11.90381,2.951904,10.95191Q3.62684,10.27697,4.5,10.0806Z" fill-rule="evenodd"/></g></svg>
</template>
<script>

export default {
  name: 'IconPlug',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
